'use strict';

const Enum = require('./enum');
const _ = require('lodash');

const Env = {
  LOCAL: 'local',
  TEST: 'test',
  DEV_AWS: 'dev-aws',
  STAGE_AWS: 'stage-aws',
  IRELAND_STAGE_AWS: 'ireland-stage-aws',
  PROD_AWS: 'prod-aws',
  IRELAND_PROD_AWS: 'ireland-prod-aws',

  /**
   * Convert NODE_ENV to an API URL.
   *
   * @deprecated Dont use this. Set URL using config instead.
   *   See https://bitbucket.org/august_team/august-google-smart-home/commits/aad1a41 for an example.
   *
   * @param {string} env - The value of NODE_ENV.
   * @param {object} [options] -
   * @param {boolean} [options.allowDefault] - Fallback to Oregon prod if a URL is not found.
   * @param {boolean} [options.includeProtocol] - Include http:// or https:// in the URL.
   * @returns {string} The API URL.
   */
  envToAPIUrl: function(env, options = {}) {
    let url;

    options = Object.assign({ allowDefault: true, includeProtocol: true }, options);

    switch (true) {
      case env === this.LOCAL:
        url = 'localhost:3030';
        break;

      case env === this.TEST:
        url = 'localhost:3535';
        break;

      case env === this.DEV_AWS:
        url = 'api-dev-aws.august.com';
        break;

      case env === this.STAGE_AWS:
      case env === this.IRELAND_STAGE_AWS:
        url = 'api-stage-aws.august.com';
        break;

      case env === this.PROD_AWS:
      case env === this.IRELAND_PROD_AWS:
      case options.allowDefault === true:
        url = 'api-production.august.com';
        break;

      default:
        throw new Error(`Invalid env: ${env}`);
    }

    if (options.includeProtocol) {
      switch (env) {
        case 'local':
        case 'test':
          url = 'http://' + url;
          break;

        default:
          url = 'https://' + url;
          break;
      }
    }

    return url;
  },
};

module.exports = {
  Env: Object.create(
    Enum,
    _.transform(Env, (result, value, key) => (result[key] = { value, enumerable: !_.isFunction(value) }))
  ),
};
